<template>
    <div v-if="screenWidth <= 800 ? true : false ">
        <el-card style="margin-bottom: 10px; height: 60px;">
            <div style="display: inline-block; float: left;">
                <el-space wrap>
                    <slot name="search-r"></slot>
                </el-space>
            </div>
            <div style="display: inline-block; float: right;">
                <slot name="search-l"></slot>
            </div>
        </el-card>
        <slot name="content"></slot>
    </div>
    <el-card shadow="never" v-else>
        <el-container>
            <el-aside :width="isCollapse ?'65px':'200px'" class="hidden-xs-only" v-show="!isCollapse">
                <el-scrollbar :height="innerHeight <= 400 ? 400 : innerHeight- 175">
                    <el-col>
                        <el-menu :collapse="isCollapse" :collapse-transition='false' @select="handleClick"
                            :default-active="defaulturi" :router="true">
                            <el-menu-item v-for="(tabsitem, tabsindex) in tab" :key="tabsindex" :index="tabsitem">
                                <el-icon>
                                    <Files style="width: 20px; height:20px;" />
                                </el-icon>
                                <template #title> {{ tabsitem }}</template>
                            </el-menu-item>
                        </el-menu>
                    </el-col>
                </el-scrollbar>
            </el-aside>
            <el-main>
                <div style="display: inline-block; float: left; ">
                    <el-space wrap>
                        <el-tooltip :content="isCollapse?'打开 侧栏':'关闭 侧栏'" placement="top" effect="light">
                            <el-switch v-model="isCollapse"
                                style="--el-switch-on-color: #909399; --el-switch-off-color: #c6e2ff" size="small" />
                        </el-tooltip>
                        <span style="color: thistle;">|</span>
                        <el-dropdown v-if="isCollapse">
                            <el-button size="small">
                                {{$route.query.id}}
                            </el-button>
                            <template #dropdown>
                                <el-dropdown-menu>
                                    <el-dropdown-item v-for="tabsitem in tab" :key="tabsitem"
                                        @click="handleClick(tabsitem)">{{ tabsitem }}</el-dropdown-item>
                                </el-dropdown-menu>
                            </template>
                        </el-dropdown>
                        <span style="color: thistle;" v-if="isCollapse">|</span>
                        <slot name="search-r"></slot>
                        <span style="color: thistle;">|</span>
                        <slot name="search"></slot>
                    </el-space>
                </div>
                <div style="display: inline-block; float: right; ">
                    <slot name="search-l"></slot>
                </div>
                <slot name="content"></slot>
            </el-main>
        </el-container>
    </el-card>
</template>

<script>
    import {
        mapState
    } from 'vuex'
    export default {
        name: "CatTabs",
        computed: {
            // Vue计算属性
            ...mapState(['screenWidth', 'innerHeight', 'uri', 'defaulturi', 'tab', 'domain']),
        },
        data() {
            return {
                isCollapse: false,
                turi: ""
            }
        },
        watch: {
            screenWidth: function(n) {
                this.isCollapse = n < 1000 ? true : false
            }
        },
        methods: {
            handleClick(v) {
                window.location.href = this.domain + '/#' + this.uri + "?id=" + v;
            }
        },
    }
</script>

<style scoped>
    .el-main {
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        padding-right: 0 !important;
    }

    .el-menu-item {
        height: 2.8rem;
    }
</style>